import { mapStore } from "../store";

export const updateGlobalSearch = (globalSearch: string) => {
  mapStore.globalSearch = globalSearch;
};

export const clearGlobalSearch = () => {
  mapStore.globalSearch = "";
};
